// Optional measurement is denied on intake, result, administrative and account pages.
export function isSensitivePath(path = window.location.pathname) {
  return /(?:admin|analytics|thank.?you|contact|assessment|smile.?visualizer|our.?results|login|register|reset|password|unsubscribe)/i.test(path);
}
export function canMeasure() {
  try {
    return window.location.origin === 'https://trinitydentalarts.com' && !isSensitivePath() && navigator.globalPrivacyControl !== true &&
      navigator.doNotTrack !== '1' && localStorage.getItem('tda_cookie_consent_v2') === 'granted';
  } catch { return false; }
}
export function publicPath(value) {
  try { const u = new URL(value, window.location.origin); return u.origin === window.location.origin ? u.pathname : ''; }
  catch { return ''; }
}
